import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { ContextMenu, MenuItem } from 'react-contextmenu';

/**
 * Project context menu.
 *
 * @param props.id {String} Menu id.
 * @param props.isTemplate {Boolean(default=false)} If set to true will show rename and download menu items.
 * @param props.onDeleteRow {Function} Handle menu item's event click.
 * @param props.onDownload {Function} To handle downloading file.
 */
const ProjectMenuComponent = ({ id, isTemplate = false, onDelete, onDownload }) => {
  const templateItems = isTemplate && (
    <MenuItem onClick={onDownload}>
      <i aria-hidden="true" className="fa fa-download" />
      Download
    </MenuItem>
  );

  return (
    <ContextMenu id={id}>
      {templateItems}
      <MenuItem onClick={onDelete}>
        <i aria-hidden="true" className="fa fa-trash" /> Delete
      </MenuItem>
    </ContextMenu>
  );
};

ProjectMenuComponent.propTypes = {
  id: PropTypes.string.isRequired,
  isTemplate: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
};

export const ProjectMenu = memo(ProjectMenuComponent);
